import React, { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import AppliedFilters from 'atom-components/applied-filters-lite';
import ErrorMessage from 'atom-components/error-message-from-hook-form';
import TextInput from 'atom-components/form-fields-for-hook-form/text-input';
import Label from 'atom-components/label';
import { groupIdFilterDefaultValue } from './filter-form.schema';

const fieldLabel = 'Group ID';
const fieldName = 'groupId';

type Props = {
  triggerFormSubmission: () => void;
};

export default function GroupIdFilter({ triggerFormSubmission }: Props): ReactElement {
  const { control, formState } = useFormContext();

  return (
    <div>
      <Label htmlFor={fieldName}>{fieldLabel}</Label>
      <TextInput
        id={fieldName}
        control={control}
        name={fieldName}
        ariaLabel={fieldLabel}
        onChange={(): void => triggerFormSubmission()}
        debounceOnChange
      />
      {formState.errors.groupId && <ErrorMessage errors={formState.errors} name="groupId" />}
    </div>
  );
}

export function GroupIdAppliedFilter({ triggerFormSubmission }: Props): ReactElement | null {
  const { watch, resetField } = useFormContext();
  const groupId = watch(fieldName);

  if (!groupId) return null;

  return (
    <AppliedFilters.Filter name={fieldLabel}>
      <AppliedFilters.FilterItem
        onClick={(): void => {
          resetField(fieldName, {
            defaultValue: groupIdFilterDefaultValue.groupId
          });
          triggerFormSubmission();
        }}
      >
        {groupId}
      </AppliedFilters.FilterItem>
    </AppliedFilters.Filter>
  );
}
